// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see NotificationsSettingsViewSettingsEvent
 */
export var NotificationsSettingsViewSettings = function (_a) {
    var settingsPage = _a.settingsPage;
    return ({
        name: "NotificationsSettings View Settings",
        parameters: {
            cdf_entity: "NotificationsSettings",
            cdf_action: "View",
            settingsPage: settingsPage !== undefined && settingsPage !== null ? settingsPage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see NotificationsSettingsViewContactMethodEvent
 */
export var NotificationsSettingsViewContactMethod = function (_a) {
    var contactMethod = _a.contactMethod;
    return ({
        name: "NotificationsSettings View ContactMethod",
        parameters: {
            cdf_entity: "NotificationsSettings",
            cdf_action: "View",
            contactMethod: contactMethod !== undefined && contactMethod !== null ? contactMethod.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see NotificationsSettingsViewPushDisabledAlertEvent
 */
export var NotificationsSettingsViewPushDisabledAlert = function (_a) {
    var settingUserId = _a.settingUserId, settingName = _a.settingName;
    return ({
        name: "NotificationsSettings View PushDisabledAlert",
        parameters: {
            cdf_entity: "NotificationsSettings",
            cdf_action: "View",
            settingUserId: settingUserId !== undefined && settingUserId !== null ? settingUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            settingName: settingName !== undefined && settingName !== null ? settingName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see NotificationsSettingsViewConfirmSheetEvent
 */
export var NotificationsSettingsViewConfirmSheet = function (_a) {
    var settingUserId = _a.settingUserId, settingName = _a.settingName, aliasType = _a.aliasType, origin = _a.origin;
    return ({
        name: "NotificationsSettings View ConfirmSheet",
        parameters: {
            cdf_entity: "NotificationsSettings",
            cdf_action: "View",
            settingUserId: settingUserId !== undefined && settingUserId !== null ? settingUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            settingName: settingName !== undefined && settingName !== null ? settingName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            aliasType: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see NotificationsSettingsViewPushBannerEvent
 */
export var NotificationsSettingsViewPushBanner = function () { return ({
    name: "NotificationsSettings View PushBanner",
    parameters: {
        cdf_entity: "NotificationsSettings",
        cdf_action: "View",
    }
}); };
/**
 * @see NotificationsSettingsChangeSettingEvent
 */
export var NotificationsSettingsChangeSetting = function (_a) {
    var settingUserId = _a.settingUserId, settingName = _a.settingName, startState = _a.startState, endState = _a.endState, aliasType = _a.aliasType;
    return ({
        name: "NotificationsSettings Change Setting",
        parameters: {
            cdf_entity: "NotificationsSettings",
            cdf_action: "Change",
            settingUserId: settingUserId !== undefined && settingUserId !== null ? settingUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            settingName: settingName !== undefined && settingName !== null ? settingName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            startState: startState !== undefined && startState !== null ? startState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            endState: endState !== undefined && endState !== null ? endState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            aliasType: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see NotificationsSettingsChangeDependentSettingEvent
 */
export var NotificationsSettingsChangeDependentSetting = function (_a) {
    var settingUserId = _a.settingUserId, settingName = _a.settingName, startState = _a.startState, endState = _a.endState, dependentUserId = _a.dependentUserId;
    return ({
        name: "NotificationsSettings Change DependentSetting",
        parameters: {
            cdf_entity: "NotificationsSettings",
            cdf_action: "Change",
            settingUserId: settingUserId !== undefined && settingUserId !== null ? settingUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            settingName: settingName !== undefined && settingName !== null ? settingName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            startState: startState !== undefined && startState !== null ? startState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            endState: endState !== undefined && endState !== null ? endState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependentUserId: dependentUserId !== undefined && dependentUserId !== null ? dependentUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see NotificationsSettingsChangeSettingErrorEvent
 */
export var NotificationsSettingsChangeSettingError = function (_a) {
    var reasonCode = _a.reasonCode;
    return ({
        name: "NotificationsSettings Change SettingError",
        parameters: {
            cdf_entity: "NotificationsSettings",
            cdf_action: "Change",
            reasonCode: reasonCode !== undefined && reasonCode !== null ? reasonCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see NotificationsSettingsAddAliasEvent
 */
export var NotificationsSettingsAddAlias = function (_a) {
    var aliasType = _a.aliasType;
    return ({
        name: "NotificationsSettings Add Alias",
        parameters: {
            cdf_entity: "NotificationsSettings",
            cdf_action: "Add",
            aliasType: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see NotificationsSettingsToggleAliasEvent
 */
export var NotificationsSettingsToggleAlias = function (_a) {
    var startState = _a.startState, endState = _a.endState, aliasType = _a.aliasType;
    return ({
        name: "NotificationsSettings Toggle Alias",
        parameters: {
            cdf_entity: "NotificationsSettings",
            cdf_action: "Toggle",
            startState: startState !== undefined && startState !== null ? startState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            endState: endState !== undefined && endState !== null ? endState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            aliasType: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see NotificationsSettingsConfirmAliasEvent
 */
export var NotificationsSettingsConfirmAlias = function (_a) {
    var settingUserId = _a.settingUserId, settingName = _a.settingName, aliasType = _a.aliasType, origin = _a.origin;
    return ({
        name: "NotificationsSettings Confirm Alias",
        parameters: {
            cdf_entity: "NotificationsSettings",
            cdf_action: "Confirm",
            settingUserId: settingUserId !== undefined && settingUserId !== null ? settingUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            settingName: settingName !== undefined && settingName !== null ? settingName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            aliasType: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
